module.exports = __webpack_public_path__ + "img/empresa-bayer-projeto-sou.437e92f4.jpg";